(function () {
  /* The EC builder focuses + scrolls its active step panel on init. Without a
     #step-N link, keep the visitor on the hero until they interact. */
  function guardInitialStepScroll() {
    if (window.__lpEcAcaStepGuard) return;
    window.__lpEcAcaStepGuard = true;
    if (/step-\d/.test(window.location.hash)) return;
    var panels = Array.prototype.slice.call(document.querySelectorAll("[data-ec-step]"));
    if (!panels.length) return;
    var noop = function () {};
    panels.forEach(function (panel) {
      panel.scrollIntoView = noop;
      panel.focus = noop;
    });
    var events = ["pointerdown", "keydown", "touchstart", "wheel"];
    function release() {
      panels.forEach(function (panel) {
        delete panel.scrollIntoView;
        delete panel.focus;
      });
      events.forEach(function (type) {
        window.removeEventListener(type, release, true);
      });
    }
    events.forEach(function (type) {
      window.addEventListener(type, release, { capture: true, passive: true });
    });
  }

  function hideVideoPoster(img) {
    img.hidden = true;
  }

  function watchVimeoPlay(frame, img) {
    var tries = 0;
    (function wait() {
      if (img.hidden) return;
      if (window.Vimeo && window.Vimeo.Player) {
        try {
          new window.Vimeo.Player(frame).on("play", function () {
            hideVideoPoster(img);
          });
        } catch (e) {}
        return;
      }
      tries += 1;
      if (tries < 60) window.setTimeout(wait, 1000);
    })();
  }

  function initVideoPosters(root) {
    var raw = root.getAttribute("data-lp-ec-video-posters");
    if (!raw) return;
    var posters;
    try {
      posters = JSON.parse(raw);
    } catch (e) {
      return;
    }
    document.querySelectorAll("[data-ec-vimeo-slide]").forEach(function (slide) {
      if (slide.querySelector(".lp-ec-aca-vposter")) return;
      var frame = slide.querySelector("iframe");
      if (!frame) return;
      var match = (frame.getAttribute("src") || "").match(/player\.vimeo\.com\/video\/(\d+)/);
      if (!match || !posters[match[1]]) return;
      var img = document.createElement("img");
      img.className = "lp-ec-aca-vposter";
      img.src = posters[match[1]];
      img.alt = "";
      img.setAttribute("aria-hidden", "true");
      img.loading = "lazy";
      img.decoding = "async";
      frame.insertAdjacentElement("afterend", img);
      var toggle = slide.querySelector("[data-ec-vimeo-toggle]");
      if (toggle) {
        toggle.addEventListener("click", function () {
          hideVideoPoster(img);
        });
      }
      img.addEventListener("click", function () {
        hideVideoPoster(img);
        var btn = slide.querySelector("[data-ec-vimeo-toggle]");
        if (btn) btn.click();
      });
      watchVimeoPlay(frame, img);
    });
  }

  function initCountdown(root) {
    var el = root.querySelector("[data-lp-ec-countdown]");
    if (!el) return;
    var timeEl = el.querySelector("[data-lp-ec-countdown-time]");
    var liveEl = el.querySelector("[data-lp-ec-countdown-live]");
    if (!timeEl) return;
    var mins = parseInt(el.getAttribute("data-lp-ec-countdown-mins"), 10) || 1440;
    var storeKey = "lp_ec_cd_" + (root.id || "aca");
    var end = parseInt(sessionStorage.getItem(storeKey), 10);
    var now = Date.now();
    if (!end || isNaN(end) || end < now) {
      end = now + mins * 60 * 1000;
      try {
        sessionStorage.setItem(storeKey, String(end));
      } catch (e) {}
    }
    function pad(n) {
      return n < 10 ? "0" + n : "" + n;
    }
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        timeEl.textContent = "00:00:00";
        if (liveEl && liveEl.textContent !== "Offer has ended") {
          liveEl.textContent = "Offer has ended";
        }
        return;
      }
      var total = Math.floor(diff / 1000);
      var h = Math.floor(total / 3600);
      var m = Math.floor((total % 3600) / 60);
      var s = total % 60;
      timeEl.textContent = pad(h) + ":" + pad(m) + ":" + pad(s);
      window.setTimeout(tick, 1000);
    }
    tick();
  }

  function syncStickyChrome(root) {
    var banner = root.querySelector(".lp-ec-aca-banner");
    if (!banner) {
      root.style.setProperty("--lp-ec-banner-height", "0px");
      return;
    }

    function updateHeight() {
      root.style.setProperty(
        "--lp-ec-banner-height",
        Math.ceil(banner.getBoundingClientRect().height) + "px"
      );
    }

    updateHeight();
    if ("ResizeObserver" in window) {
      new ResizeObserver(updateHeight).observe(banner);
    } else {
      window.addEventListener("resize", updateHeight, { passive: true });
    }
  }

  function init(root) {
    if (!root || root.getAttribute("data-lp-ec-aca-init") === "1") return;
    root.setAttribute("data-lp-ec-aca-init", "1");
    initCountdown(root);
    syncStickyChrome(root);
    initVideoPosters(root);
  }

  function boot() {
    guardInitialStepScroll();
    document.querySelectorAll("[data-lp-ec-aca-root]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  document.addEventListener("shopify:section:load", function (e) {
    var r = e.target && e.target.querySelector("[data-lp-ec-aca-root]");
    if (r) {
      r.removeAttribute("data-lp-ec-aca-init");
      init(r);
    }
  });
})();
